import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { License } from '../../../stores/types';
import { LabelType, MODAL_TYPES, MenuItem, useGlobalModalContext } from '../../_ui';
import { LicenseEdit } from '../EditLicense.component';
import { getLicenseType, isLicenseTypeDemo, LICENSE_STATUS } from '../utils';

interface EditLicenseMenuItemProps {
  license: License;
}

export const EditLicenseMenuItem: React.FC<EditLicenseMenuItemProps> = ({ license }) => {
  const { showModal } = useGlobalModalContext();
  const { t } = useTranslation();

  const handleEditLicense = useCallback(() => {
    showModal(MODAL_TYPES.INFO_MODAL, {
      title: t('edit_license_editor_title'),
      width: '540px',
      height: 'max-content',
      onRenderBody: () => <LicenseEdit license={license} />,
      shouldCloseOnOverlayClick: false,
    });
  }, [showModal, t, license]);

  const licenseStatusUnassigned = (row: License) => {
    return row.status?.toLowerCase() === LICENSE_STATUS.UNASSIGNED.toLowerCase();
  };

  const isDemoLicense = isLicenseTypeDemo(getLicenseType(license.type));

  return licenseStatusUnassigned(license) && !isDemoLicense ? (
    <MenuItem
      label={t('edit_license_menu_title')}
      labelType={LabelType.BODY3}
      onClick={handleEditLicense}
      dataTestId='license-edit-button'
    />
  ) : null;
};
